module.exports = __webpack_public_path__ + "static/media/kf2-xmas-divider.db72287f.png";